import React, { useMemo } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import Sprite from 'core/tools/Sprite';
import { isNumber, isString } from 'lodash';

// MAINT COMPONENT
const DollarsCell = ({
  children,
  value = children,
  icon,
  colorCoded
}) => {

  // MEMOS
  const floatValue = useMemo(
    () => {
      if (!value) return 0;
      if (isNumber(value)) return value;
      if (!isString) return;
      if (!value.trim()) return;
      const isNegative = value.search(/[-(]/g) === 0;
      let floatValue = parseFloat(value.replace(/[$,()-]/g, ''));
      if (isNegative) floatValue = -floatValue;
      return floatValue
    },
    [value]
  )

  // RENDER
  return (
    <div className={clsx(
      'text-end',
      colorCoded && (floatValue < 0 ? 'text-danger' : floatValue > 0 ? 'text-success' : undefined)
    )}>
      {floatValue.toLocaleString('en-US', { style: 'currency', currency: 'USD', currencySign: 'accounting' })}
      {!!icon && <Sprite {...icon} />}
    </div>
  );
}
DollarsCell.ColorCoded = props => <DollarsCell {...props} colorCoded={true} />;

// EXPORT
export default DollarsCell;
